import { create } from 'zustand';
import { MealResponse } from '../api/generated/models';

interface MealCacheState {
  meals: Record<string, MealResponse>;
  addMeal: (meal: MealResponse) => void;
  removeMeal: (mealId: string) => void;
  updateMeal: (mealId: string, updates: Partial<MealResponse>) => void;
  clearCache: () => void;
  getMeal: (mealId: string) => MealResponse | undefined;
}

export const useMealCache = create<MealCacheState>((set, get) => ({
  meals: {},

  addMeal: (meal) =>
    set((state) => ({
      meals: { ...state.meals, [meal.id]: meal },
    })),

  removeMeal: (mealId) =>
    set((state) => {
      const { [mealId]: removed, ...remaining } = state.meals;
      return { meals: remaining };
    }),

  updateMeal: (mealId, updates) =>
    set((state) => ({
      meals: {
        ...state.meals,
        [mealId]: { ...state.meals[mealId], ...updates },
      },
    })),

  clearCache: () => set({ meals: {} }),

  getMeal: (mealId) => get().meals[mealId],
}));
